<template>
  <v-app dark>
    <v-col>
      <ValidationObserver ref="pollValidation"
                          v-slot="{ invalid, passes }">
        <v-row>
          <v-col
            cols="12">
            Záněty varlat a urogenitálního traktu
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.testicularUrogenitalTractInflammation.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.testicularUrogenitalTractInflammation.status == '1' ? 'required' : ''"
              v-model="form.testicularUrogenitalTractInflammation.value"
              label="Jaké?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.testicularUrogenitalTractInflammation.status != '1'" />
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.testicularUrogenitalTractInflammation.status == '1' ? 'required' : ''"
              v-model="form.testicularUrogenitalTractInflammation.valueAge"
              label="V jakém věku?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.testicularUrogenitalTractInflammation.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Nádory varlat a urogenitálního traktu
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.testicularUrogenitalTractTumors.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.testicularUrogenitalTractTumors.status == '1' ? 'required' : ''"
              v-model="form.testicularUrogenitalTractTumors.value"
              label="Jaké?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.testicularUrogenitalTractTumors.status != '1'" />
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.testicularUrogenitalTractTumors.status == '1' ? 'required' : ''"
              v-model="form.testicularUrogenitalTractTumors.valueAge"
              label="V jakém věku?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.testicularUrogenitalTractTumors.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Úrazy varlat
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.testicularInjuries.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.testicularInjuries.status == '1' ? 'required' : ''"
              v-model="form.testicularInjuries.value"
              label="Jaké?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.testicularInjuries.status != '1'" />
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.testicularInjuries.status == '1' ? 'required' : ''"
              v-model="form.testicularInjuries.valueAge"
              label="V jakém věku?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.testicularInjuries.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Operace varlat a urogenitálního traktu
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.testicularUrogenitalTractOperation.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.testicularUrogenitalTractOperation.status == '1' ? 'required' : ''"
              v-model="form.testicularUrogenitalTractOperation.value"
              label="Jaké?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.testicularUrogenitalTractOperation.status != '1'" />
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.testicularUrogenitalTractOperation.status == '1' ? 'required' : ''"
              v-model="form.testicularUrogenitalTractOperation.valueAge"
              label="V jakém věku?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.testicularUrogenitalTractOperation.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Spermiogram
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.spermiogram.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col
            cols="8"
            class="pt-0">
            <VTextFieldWithValidation
              :rules="form.spermiogram.status == '1' ? 'required' : ''"
              v-model="form.spermiogram.value"
              label="Výsledek vyšetření"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.spermiogram.status != '1'" />
          </v-col>
          <v-col
            cols="4"
            class="pt-0">
            <v-menu
              v-model="datePickerMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="mt-0 pt-0"
                  v-model="computedDateFormatted"
                  label="Kdy"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  :disabled="form.spermiogram.status !== '1'" />
              </template>
              <v-date-picker
                ref="datePickerMenu"
                locale="cs"
                color="blue lighten-1"
                v-model="spermiogramDate"
                @input="datePickerMenu = false"
                :show-current="false"
                :max="new Date().toISOString().substr(0, 10)"
                min="1920-01-01"
                :first-day-of-week="1" />
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Vyskytlo se u Vás nádorové onemocnění?
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.cancer.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.cancer.status == '1' ? 'required' : ''"
              v-model="form.cancer.value"
              label="Jaké?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.cancer.status != '1'" />
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.cancer.status == '1' ? 'required' : ''"
              v-model="form.cancer.valueAge"
              label="V jakém věku?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.cancer.status != '1'" />
          </v-col>
          <v-col
            cols="auto">
            <v-btn @click="submit()"
                   type="submit"
                   x-large
                   depressed
                   height="68px"
                   class="px-12 white--text"
                   color="blue lighten-1">
              Uložit
            </v-btn>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-col>
  </v-app>
</template>

<script>
export default {
  name: 'TheUrologicalHistory',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: {
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        testicularUrogenitalTractInflammation: {
          status: 0,
          value: '',
          valueAge: '',
        },
        testicularUrogenitalTractTumors: {
          status: 0,
          value: '',
          valueAge: '',
        },
        testicularInjuries: {
          status: 0,
          value: '',
          valueAge: '',
        },
        testicularUrogenitalTractOperation: {
          status: 0,
          value: '',
          valueAge: '',
        },
        spermiogram: {
          status: 0,
          value: '',
          valueAge: '',
        },
        cancer: {
          status: 0,
          value: '',
          valueAge: '',
        }
      },
      spermiogramDate: '',
      datePickerMenu: false,
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
    };
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.spermiogramDate);
    },
    formtosend() {
      // eslint-disable-next-line no-new-object
      return new Object({
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        testicularUrogenitalTractInflammation: {
          status: Number(this.form.testicularUrogenitalTractInflammation.status),
          value: JSON.stringify({
            what: this.form.testicularUrogenitalTractInflammation.value,
            age: this.form.testicularUrogenitalTractInflammation.valueAge,
          })
        },
        testicularUrogenitalTractTumors: {
          status: Number(this.form.testicularUrogenitalTractTumors.status),
          value: JSON.stringify({
            what: this.form.testicularUrogenitalTractTumors.value,
            age: this.form.testicularUrogenitalTractTumors.valueAge,
          })
        },
        testicularInjuries: {
          status: Number(this.form.testicularInjuries.status),
          value: JSON.stringify({
            what: this.form.testicularInjuries.value,
            age: this.form.testicularInjuries.valueAge,
          })
        },
        testicularUrogenitalTractOperation: {
          status: Number(this.form.testicularUrogenitalTractOperation.status),
          value: JSON.stringify({
            what: this.form.testicularUrogenitalTractOperation.value,
            age: this.form.testicularUrogenitalTractOperation.valueAge,
          })
        },
        spermiogram: {
          status: Number(this.form.spermiogram.status),
          value: JSON.stringify({
            result: this.form.spermiogram.value,
            date: `${this.spermiogramDate}T00:00:00.000Z`,
          })
        },
        cancer: {
          status: Number(this.form.cancer.status),
          value: JSON.stringify({
            what: this.form.cancer.value,
            age: this.form.cancer.valueAge,
          })
        }
      });
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    birthday(val) {
      this.dateFormatted = this.formatDate(this.spermiogramDate);
    },
  },
  methods: {
    formatDate(spermiogramDate) {
      if (!spermiogramDate) return null;

      const [year, month, day] = spermiogramDate.split('-');
      return `${day}.${month}.${year}`;
    },
    async submit() {
      const valid = await this.$refs.pollValidation.validate();

      if (!valid) {
        return false;
      }

      const form = this.formtosend;
      form.CustomerId = this.id;

      document.getElementById('genscanLogoDiv').scrollIntoView();

      this.axios.put('admin/questionnaires/urologymenpart', form).then((res) => {
        if (res.status === 200) {
          this.$root.$bvToast.toast(this.$t('Questionnaires.SuccessToast.Body'), {
            title: this.$t('Questionnaires.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.$emit('completed');
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Questionnaires.FailureToast.Body'), {
          title: this.$t('Questionnaires.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });

      return true;
    }
  },
  created() {
    this.axios.get('admin/questionnaires/urologymenpart', {
      params: {
        CustomerId: this.id
      }
    }).then((response) => {
      const data = response.data.result;

      this.form = {
        testicularUrogenitalTractInflammation: {
          status: String(data.testicularUrogenitalTractInflammation.status),
          value: JSON.parse(data.testicularUrogenitalTractInflammation.value).what,
          valueAge: JSON.parse(data.testicularUrogenitalTractInflammation.value).age,
        },
        testicularUrogenitalTractTumors: {
          status: String(data.testicularUrogenitalTractTumors.status),
          value: JSON.parse(data.testicularUrogenitalTractTumors.value).what,
          valueAge: JSON.parse(data.testicularUrogenitalTractTumors.value).age,
        },
        testicularInjuries: {
          status: String(data.testicularInjuries.status),
          value: JSON.parse(data.testicularInjuries.value).what,
          valueAge: JSON.parse(data.testicularInjuries.value).age,
        },
        testicularUrogenitalTractOperation: {
          status: String(data.testicularUrogenitalTractOperation.status),
          value: JSON.parse(data.testicularUrogenitalTractOperation.value).what,
          valueAge: JSON.parse(data.testicularUrogenitalTractOperation.value).age,
        },
        spermiogram: {
          status: String(data.spermiogram.status),
          value: JSON.parse(data.spermiogram.value).result
        },
        cancer: {
          status: String(data.cancer.status),
          value: JSON.parse(data.cancer.value).what,
          valueAge: JSON.parse(data.cancer.value).age,
        }
      };

      // eslint-disable-next-line prefer-destructuring
      this.spermiogramDate = JSON.parse(data.spermiogram.value).date.split('T', 1)[0];
    });
  }
};
</script>
